// The theme preference: System (default), Light, or Dark. Applied as `data-theme` on
// `<html>` — System removes the attribute and leaves it to `prefers-color-scheme`, same
// as before this existed; Light/Dark force it either way (see `styles.css`). Storage and
// subscription are `preferences.ts`'s; this module only owns applying the value to the DOM.

import { createPreference } from './preferences.js';

export type ThemePreference = 'system' | 'light' | 'dark';

const store = createPreference<ThemePreference>(
  'theme',
  ['system', 'light', 'dark'],
  'system',
);

function apply(value: ThemePreference): void {
  const root = globalThis.document?.documentElement;
  if (value === 'system') {
    root?.removeAttribute('data-theme');
  } else {
    root?.setAttribute('data-theme', value);
  }
}

apply(store.get());

export const theme = {
  get: store.get,
  set(value: ThemePreference): void {
    store.set(value);
    apply(value);
  },
  subscribe: store.subscribe,
};
